export default function prettifyDate(date: string | number | Date): string {
	return new Date(date).toLocaleString(undefined, {
		year: "numeric",
		month: "numeric",
		day: "numeric",
		hour: "numeric",
		minute: "numeric",
		second: "numeric",
		hour12: true,
	}).replace(",", " at ");
}
